<h3 id="title">
    ACERCA DE NOSOTROS
</h3>
<div id="ig">
    <img id="image" src="/assets/images/priscilla-du-preez-HG1pJiQHXzs-unsplash.jpg" alt="">
    <div id="crSe">
        <bm-about-us-card title="{{title}}" description="{{description}}" [items]="itemsList"></bm-about-us-card>
        <bm-about-us-selector (pressed)="onPressed($event)"></bm-about-us-selector>
    </div>
</div>